(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }

  // Read vars from attributes
  var productId = productRecommendationsSection.dataset.productId;
  var limit = productRecommendationsSection.dataset.limit;
  var adv_ratio = productRecommendationsSection.dataset.adv_ratio;
  var prod_thumb_img_ratio = productRecommendationsSection.dataset.prod_thumb_img_ratio;

  // Build request URL
  var baseUrl = productRecommendationsSection.dataset.url + '?section_id=product-recommendations&limit=' + limit + '&product_id=' + productId;

  // LOOM 14 oct 2026: primero las piezas a juego elegidas a mano (intent=complementary).
  // Si el producto no tiene ninguna con stock visible, se cae a las recomendaciones de siempre (related).
  var fetchSection = function(intent, onEmpty) {
    var request = new XMLHttpRequest();
    request.open("GET", baseUrl + '&intent=' + intent);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        var incoming = container.querySelector(".product-recommendations");
        var hasProducts = incoming && incoming.querySelector('a[href*="/products/"]');
        if (!hasProducts && onEmpty) { onEmpty(); return; }
        if (!incoming) { return; }
        productRecommendationsSection.innerHTML = incoming.innerHTML;

        // set correct image shape
        if(adv_ratio == 'true'){
          var $firstImage = $('.rimage-wrapper:first', productRecommendationsSection);
          var ar = $firstImage.width() / $firstImage.outerHeight();
          $('.rimage-wrapper:not(:first)', productRecommendationsSection).each(function(){
            var thisAr = $(this).width() / $(this).outerHeight();
            if(
              (prod_thumb_img_ratio == 'tallest' && thisAr < ar) ||
              (prod_thumb_img_ratio == 'shortest' && thisAr > ar)
            ) {
              ar = thisAr;
            }
          });
          if(prod_thumb_img_ratio == 'tallest' || prod_thumb_img_ratio == 'shortest') {
            $('.rimage-wrapper', productRecommendationsSection).css('padding-top', ((1.0 / ar) * 100.0).toFixed(2) + '%');
          }
        }

        // init masonry layout
        $(document).trigger('loadmasonry');
      } else if (onEmpty) {
        onEmpty();
      }
    };
    request.onerror = function() { if (onEmpty) { onEmpty(); } };
    request.send();
  };

  fetchSection('complementary', function() { fetchSection('related', null); });
};

// Reload the section as you edit theme settings
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});

// When the section is unloaded, detach the Masonry plugin to tidy up
document.addEventListener("shopify:section:unload", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    $('.blocklayout', event.target).masonry('destroy');
  }
});

// Fetching the recommendations on page load
document.addEventListener("DOMContentLoaded", function(event) {
  loadProductRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();
})();
